import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import breadcrumb from './breadcrumb'
import attendance from './attendance'
import physicianSignUp from './physician-sign-up'
import newAttendanceForm from './new-attendance-form'
import medicalDocument from './medical-document'
import patient from './patient'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: { auth, breadcrumb, attendance, physicianSignUp, newAttendanceForm, medicalDocument, patient },
})
